import { SNAP_ANGLE_DEG } from '../../sim/map/snap.ts';
import { BOAT_LENGTH_M, metersToPixels } from '../../sim/constants.ts';
import { screenToWorld } from '../view.ts';

/** Screen gap between the cursor and the hull centre, plus half a length. */
export const BOAT_GUIDE_OFFSET_PX = 30;

/** Same display size as a play hull: 7 m long, beam half of that. */
export const BOAT_GUIDE_LENGTH_PX = metersToPixels(BOAT_LENGTH_M);
export const BOAT_GUIDE_BEAM_PX = metersToPixels(BOAT_LENGTH_M / 2);

/** One mouse-wheel notch while B is held. Same step as the rotate tool's snap. */
export const BOAT_GUIDE_WHEEL_STEP_DEG = SNAP_ANGLE_DEG;

/**
 * World centre of the editor hull guide. The centre sits `BOAT_GUIDE_OFFSET_PX` screen
 * pixels plus half a hull length to the right of the cursor, so the click point stays clear
 * while the sprite spins about that centre.
 */
export function boatGuideCenter(
  cursorWorldX: number,
  cursorWorldY: number,
  zoom: number,
): { x: number; y: number } {
  return {
    x: cursorWorldX + screenToWorld(BOAT_GUIDE_OFFSET_PX, zoom) + BOAT_GUIDE_LENGTH_PX / 2,
    y: cursorWorldY,
  };
}

/** 0 is bow-right, positive is clockwise. Wheel down turns clockwise. Result is degrees in [0, 360). */
export function boatGuideHeadingAfterWheel(headingDeg: number, deltaY: number): number {
  if (deltaY === 0) {
    return headingDeg;
  }

  const next = headingDeg + Math.sign(deltaY) * BOAT_GUIDE_WHEEL_STEP_DEG;
  return ((next % 360) + 360) % 360;
}
